export enum PollData_Poll_Settings_Permissions_ViewRole {
  /** CREATOR - Only Poll creator can view the results */
  CREATOR = 'CREATOR',
  /** VOTERS - Anyone who voted can see the results */
  VOTERS = 'VOTERS',
  /** EVERYONE - Anyone can see the results, even if one didn't vote */
  EVERYONE = 'EVERYONE',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum PollData_Poll_Settings_Permissions_VoteRole {
  /** SITE_MEMBERS - Logged in member */
  SITE_MEMBERS = 'SITE_MEMBERS',
  /** ALL - Anyone */
  ALL = 'ALL',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum PollData_Layout_PollLayout_Type {
  /** LIST - List */
  LIST = 'LIST',
  /** GRID - Grid */
  GRID = 'GRID',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum PollData_Layout_PollLayout_Direction {
  /** LTR - Left-to-right */
  LTR = 'LTR',
  /** RTL - Right-to-left */
  RTL = 'RTL',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum PollData_Design_PollDesign_Background_Type {
  /** COLOR - Color background type */
  COLOR = 'COLOR',
  /** IMAGE - Image background type */
  IMAGE = 'IMAGE',
  /** GRADIENT - Gradiant background type */
  GRADIENT = 'GRADIENT',
  UNRECOGNIZED = 'UNRECOGNIZED',
}